// src/pages/Developing.jsx
import React from 'react';

const Developing = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      backgroundColor: '#000000', // nero
      color: '#ffffff' // testo bianco per contrasto
    }}>
      <h1>🚧 Page Under Development 🚧</h1>
      <p>Questa pagina è in fase di sviluppo. Torna presto!</p>
    </div>
  );
};

export default Developing;
